const ErrorHandler = {
  handle: (error: any) => {
    console.error(error)
  },
}

export default ErrorHandler
